import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Documentos from "./views/Interno.vue";
import Impugnacao from "./views/Impugnacao.vue";
import Protocolo from "./views/Protocolo.vue";
import Aprovador from "./views/Aprovador.vue";
import AlteracaoCadastral from "./views/AlteracaoCadastral.vue";
import Isencao from "./views/Isencao.vue";
import ProtocoloAlteracaoCadastral from "./views/ProtocoloAlteracaoCadastral.vue";
import Titulos from "./views/Titulos.vue";
import ProtocoloTitulos from "./views/ProtocoloTitulos";
import LoginAvaliador from "@/views/LoginAvaliador";
import AprovadorTitulos from "@/views/AprovadorTitulos";
import PDFThumbnail from "@/views/PDFThumbnail";
import AprovadorTitulosInterno from "@/views/AprovadorTitulosInterno";
import ProtocoloImpugnacao from "@/views/ProtocoloImpugnacao";
import PGM_Inscricao from "@/views/PGM_Inscricao";
import PGM_Protocolo from "@/views/PGM_Protocolo";

import C2109_Pratica_Digitador from "@/views/2109_Pratica_Digitador";
import C2106_Recurso_Classificacao from "@/views/LoginRecursoClassificacao_2106";
import C2109_Recurso_Pratica from "@/views/2109_LoginRecursoPratica";
import C2109_Recurso_Classificacao from "@/views/2109_LoginRecursoClassificacao";
import C2002_Recurso_AV_PSICO from "@/views/2002_LoginRecursoPsico";
import C2112_Recurso_ISENCAO from "@/views/2112_LoginRecursoIsencao";
import C2113_Recurso_ISENCAO from "@/views/2113_LoginRecursoIsencao";
import C2111_Recurso_GABARITO from "@/views/2111_LoginRecursoGabarito";
import C2110_Recurso_GABARITO from "@/views/2110_LoginRecursoGabarito";
import C2203_Recurso_ISENCAO from "@/views/2203_LoginRecursoIsencao";
import C2203_Recurso_ISENCAO_2 from "@/views/2203_LoginRecursoIsencao_2";
import C2110_Recurso_PO from "@/views/2110_LoginRecursoPO";
import C2111_Recurso_PO from "@/views/2111_LoginRecursoPO";
import C2204_Recurso_ISENCAO from "@/views/2204_LoginRecursoIsencao";
import C2113_Recurso_INSCRICAO from "@/views/2113_LoginRecursoInscricao";
import C2114_Recurso_INSCRICAO from "@/views/2114_LoginRecursoInscricao";
import C2201_Recurso_INSCRICAO from "@/views/2201_LoginRecursoInscricao";
import C2202_Recurso_INSCRICAO from "@/views/2202_LoginRecursoInscricao";
import C2205_Recurso_IMPUGNACAO from "@/views/2205_LoginRecursoImpugnacao";
import C2113_Recurso_GABARITO from "@/views/2113_LoginRecursoGabarito";
import C2112_Recurso_GABARITO from "@/views/2112_LoginRecursoGabarito";
import C2113_Recurso_PCD from "@/views/2113_LoginRecursoPCD";
import C2112_Recurso_PCD from "@/views/2112_LoginRecursoPCD";
import C2203_Recurso_INSCRICAO from "@/views/2203_LoginRecursoInscricao";
import C2112_Recurso_PO from "@/views/2112_LoginRecursoPO";
import C2113_Recurso_PO from "@/views/2113_LoginRecursoPO";
import C1922_Recurso_HETERO from "@/views/1922_LoginRecursoHetero";
import C2114_Recurso_GABARITO from "@/views/2114_LoginRecursoGabarito";
import C2204_Recurso_INSCRICAO from "@/views/2204_LoginRecursoInscricao";
import C2201_Recurso_GABARITO from "@/views/2201_LoginRecursoGabarito.vue";
import C2202_Recurso_GABARITO from "@/views/2202_LoginRecursoGabarito.vue";
import C2201_Recurso_PO from "@/views/2201_LoginRecursoPO";
import C2202_Recurso_PO from "@/views/2202_LoginRecursoPO";
import C2114_Recurso_PO from "@/views/2114_LoginRecursoPO";
import C2114_Recurso_PCD from "@/views/2114_LoginRecursoPCD";
import C2205_Recurso_ISENCAO from "@/views/2205_LoginRecursoIsencao";
import C2114_Recurso_TITULO from "@/views/2114_LoginRecursoTitulos";
import C2207_Recurso_IMPUGNACAO from "@/views/2207_LoginRecursoImpugnacao";
import C2206_Recurso_ISENCAO from "@/views/2206_LoginRecursoIsencao";
import C2203_Recurso_GABARITO from "@/views/2203_LoginRecursoGabarito.vue";
import C2203_Recurso_PO from "@/views/2203_LoginRecursoPO";
import C2202_Recurso_PRAT from "@/views/2202_LoginRecursoPrat";
import C2207_Recurso_ISENCAO from "@/views/2207_LoginRecursoIsencao";
import C2209_Recurso_ISENCAO from "@/views/2209_LoginRecursoIsencao";
import C2204_Recurso_GABARITO from "@/views/2204_LoginRecursoGabarito";
import C2208_Recurso_ISENCAO from "@/views/2208_LoginRecursoIsencao";
import C2202_Recurso_TITULOS from "@/views/2202_LoginRecursoTitulos";
import C2204_Recurso_PO from "@/views/2204_LoginRecursoPO";
import C2212_Recurso_PO from "@/views/2212_LoginRecursoIsencao";
import C2205_Recurso_PO from "@/views/2205_LoginRecursoInscricao";
import C2206_Recurso_INSCRICAO from "@/views/2206_LoginRecursoInscricao";
import C2202_Recurso_Classificacao from "@/views/2202_LoginRecursoClassificacao";
import C2210_Recurso_ISENCAO from "@/views/2210_LoginRecursoIsencao";
import C2201_Prova_Pratica from "@/views/2201_LoginProvaPratica";
import C2208_Recurso_INSCRICAO from "@/views/2208_LoginRecursoInscricao";
import C2211_Recurso_IMPUGNACAO from "@/views/2211_LoginRecursoImpugnacao";
import C2201_Preliminar_Titulos from "@/views/2201_LoginPreliminarTitulos";
import C2201_Recurso_Discursiva from "@/views/2201_LoginRecursoDiscursiva";
import C2201_Recurso_Pratica from "@/views/2201_LoginRecursoPratica";
import C2209_Recurso_INSCRICAO from "@/views/2209_LoginRecursoInscricao";
import C2210_Recurso_INSCRICAO from "@/views/2210_LoginRecursoInscricao";
import C2212_Recurso_INSCRICAO from "@/views/2212_LoginRecursoInscricao";
import C2211_Recurso_ISENCAO from "@/views/2211_LoginRecursoIsencao";
import C2205_Recurso_GABARITO from "@/views/2205_LoginRecursoGabarito";
import C2204_Nota_Discursiva from "@/views/2204_LoginProvaDiscursiva";
import C2204_Nota_Titulos from "@/views/2204_LoginTitulos";
import C2201_Recurso_Titulos from "@/views/2201_LoginRecursoTitulos";
import C2205_DISCURSIVA from "@/views/2205_LoginDiscursiva";
import C2205_RECURSO_PO from "@/views/2205_LoginRecursoPO";
import C2206_Recurso_GABARITO from "@/views/2206_LoginRecursoGabarito";
import C2204_Recurso_TITULO from "@/views/2204_LoginRecursoTitulo";
import C2204_Nota_Titulos_DEF from "@/views/2204_LoginTitulos_Def";
import C2204_RECURSO_DISC from "@/views/2204_LoginRecursoDiscursiva";
import C2205_RECURSO_DISC from "@/views/2205_LoginRecursoDiscursiva";
import C2208_Recurso_GABARITO from "@/views/2208_LoginRecursoGabarito";
import C2205_Nota_DISC_DEF from "@/views/2205_LoginDiscursivaDef";
import C2204_Nota_DISC_DEF from "@/views/2204_LoginDiscursivaDef";
import C2206_RECURSO_PO from "@/views/2206_LoginRecursoPO";
import C2207_Recurso_INSCRICAO from "@/views/2207_LoginRecursoInscricao";
import C2204_Recurso_RES_PREM from "@/views/2204_LoginRecursoResPrem";
import C2205_Nota_Tit from "@/views/2205_LoginNotaTitulos.vue";
import C2205_RES_LAUDO_PCD from "@/views/2205_LoginLaudoPCD.vue";
import C2215_Recurso_IMPUGNACAO from "@/views/2215_LoginRecursoImpugnacao";
import C2209_Recurso_GABARITO from "@/views/2209_LoginRecursoGabarito";
import C2210_Recurso_GABARITO from "@/views/2210_LoginRecursoGabarito";
import C2212_Recurso_GABARITO from "@/views/2212_LoginRecursoGabarito";
import C2203_Recurso_QUESTINARIO from "@/views/2203_LoginResInvestigacao";
import C2203_Recurso_EXAME from "@/views/2203_LoginResExame";
import C2208_RECURSO_PO from "@/views/2208_LoginRecursoPO";
import C2209_RECURSO_PO from "@/views/2209_LoginRecursoPO";
import C2210_RECURSO_PO from "@/views/2210_LoginRecursoPO";
import C2208_RES_DISC from "@/views/2208_LoginResultadoDiscursiva";
import C2208_RES_HETERO from "@/views/2208_LoginResultadoHetero";
import C2209_Nota_Tit from "@/views/2209_LoginNotaTitulos.vue";
import C2210_Nota_Tit from "@/views/2210_LoginNotaTitulos.vue";
import C2205_RECURSO_TITULO from "@/views/2205_LoginRecursoTitulos.vue";
import C2205_LAUDO_PCD_DEF from "@/views/2205_LoginLaudoPCD_DEF";
import C2205_RECURSO_LAUDO from "@/views/2205_LoginRecursoLaudoPCD.vue";
import C2205_Nota_Tit_Def from "@/views/2205_LoginNotaTit_Def.vue";
import C2205_RECURSO_TAF from "@/views/2205_LoginRecursoTAF.vue";
import C2209_RECURSO_TIT from "@/views/2209_LoginRecursoTitulos";
import C2210_RECURSO_TIT from "@/views/2210_LoginRecursoTitulos";
import C2203_REC_QUEST from "@/views/2203_LoginRecursoResInvestigacao";
import C2203_REC_EXAME from "@/views/2203_LoginRecExame";
import C2203_RES_DEF_EXAME from "@/views/2203_LoginResDefExame";
import C2203_RES_DEF_QUEST from "@/views/2203_LoginResDefInvestigacao";
import C2208_REC_HETERO from "@/views/2208_LoginRecHetero";
import C2203_JUST_INAPT_EXAME from "@/views/2203_LoginJustInapt_Exame_Def";
import C2208_REC_DISC from "@/views/2208_LoginRecDiscursiva";
import C2208_RES_DISC_DEF from "@/views/2208_LoginResultadoDiscursivaDef";
import C2208_RES_HETERO_DEF from "@/views/2208_LoginResultadoDefHetero";
import C2205_REC_RES_PREM from "@/views/2205_LoginRecursoResPrem";
import C2212_REC_PO from "@/views/2212_LoginRecursoPO";
import C2214_REC_INS from "@/views/2214_LoginRecursoIsencao";
import C2211_REC_INSC from "@/views/2211_LoginRecursoInscricao";
import C2218_IMPUGNACAO from "@/views/2218_LoginRecursoImpugnacao";
import C2212_REC_TAF from "@/views/2212_LoginRecursoTAF";
import C2215_REC_ISENC from "@/views/2215_LoginRecursoIsencao";
import C2217_REC_ISENC from "@/views/2217_LoginRecursoIsencao";
import C2220_REC_ISENC from "@/views/2220_LoginRecursoIsencao";
import C2219_REC_ISENC from "@/views/2219_LoginRecursoIsencao";
import C2216_RES_IMPU from "@/views/2216_LoginRecursoImpugnacao";
import C2207_RES_GAB from "@/views/2207_LoginRecursoGabarito";
import C2218_REC_ISENC from "@/views/2218_LoginRecursoIsencao";
import C2207_Recurso_PO from "@/views/2207_LoginRecursoPO";
import C2221_REC_ISENC from "@/views/2221_LoginRecursoIsencao";
import C2215_REC_INSCR from "@/views/2215_LoginRecursoInscricao";
import C2207_RES_HETERO from "@/views/2207_LoginResHetero";
import C2207_RES_PCD from "@/views/2207_LoginResPCD";
import C2219_RES_INSC from "@/views/2219_LoginRecursoInscricao";
import C2207_REC_HETERO from "@/views/2207_LoginRecursoHetero";
import C2207_REC_PCD from "@/views/2207_LoginRecursoPCD";
import C2207_RES_DEF_HETERO from "@/views/2207_LoginResDefHetero";
import C2207_RES_DEF_PCD from "@/views/2207_LoginResDefPCD";
import C2220_RES_INSCRICAO from "@/views/2220_LoginResInscricao";
import C2207_RES_BANCA from "@/views/2207_LoginResDefHeteroBanca";
import C2217_REC_ISENCAO_2 from "@/views/2217_LoginRecursoIsencao";
import C2211_REC_GAB from "@/views/2211_LoginRecursoGabarito";
import C2218_REC_INSCRICAO from "@/views/2218_LoginRecursoInscricao";
import C2216_RES_INSENCAO from "@/views/2216_LoginResultadoIsencao";
import C2220_CONSULTA_GABARITO from "@/views/2220_LoginConsultaGabarito";
import C2220_CONSULTA_CADERNO from "@/views/2220_LoginConsultaCaderno";
import C2214_REC_GABARITO from "@/views/2214_LoginRecursoGabarito";
import C2222_RES_INSENCAO from "@/views/2222_LoginRecursoIsencao";
import C2224_IMPUGNACAO from "@/views/2224_LoginRecursoImpugnacao";
import C2219_REC_GABARITO from "@/views/2219_LoginRecursoGabarito";
import C2216_REC_ISENCAO from "@/views/2216_LoginRecursoIsencao";
import C2216_RES_DEF_ISENCAO from "@/views/2216_LoginResultadoIsencaoDef";
import C2211_RES_DISC from "@/views/2211_LoginResDisc";
import C2211_REC_PO from "@/views/2211_LoginRecursoPO";
import C2211_ESP_INV from "@/views/2211_LoginESPINV";
import C2211_ESP_ESC from "@/views/2211_LoginESPESC";
import C2211_REC_GABA_DEL from "@/views/2211_LoginRecurso_Gaba_Del";
import C2214_REC_PO from "@/views/2214_LoginRecursoPO";
import C2221_REC_GABA from "@/views/2221_LoginRecursoGabarito";
import C2219_RES_DISC from "@/views/2219_LoginResDisc";
import C2219_REC_PO from "@/views/2219_LoginRecursoPO";
import C2218_REC_GABA from "@/views/2218_LoginRecursoGabarito";
import C2216_RES_DEF_ISENCAO_2 from "@/views/2216_LoginResultadoIsencaoDef2";
import C2221_REC_PO from "@/views/2221_LoginRecursoPO";
import C2217_REC_INSC from "@/views/2217_LoginRecursoInsc";
import C2224_REC_INSEN from "@/views/2224_LoginRecursoIsencao";
import C2220_REC_GABA from "@/views/2220_LoginRecursoGabarito";
import C2220_CONSULTA_GABARITO_DEF from "@/views/2220_LoginConsultaGabaritoDef";
import C2216_REC_ISENC_2 from "@/views/2216_LoginRecursoIsencao_2";
import C2211_RES_DELEGADO from "@/views/2211_LoginResDisc_Delegado";
import C2211_REC_PO_DEL from "@/views/2211_LoginRecursoPO_Dek";
import C2220_GABA_FO from "@/views/2220_LoginGabaFISCOB";
import C2220_CADERNO_FO from "@/views/2220_LoginCadernoFISCOB";
import C2228_IMPUG from "@/views/2228_LoginRecursoImpugnacao";
import C2303_IMPUG from "@/views/2303_LoginRecursoImpugnacao.vue";

Vue.use(Router);

let router = new Router({
  mode: 'history',
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/login/:concurso",
      name: "login",
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter
      }
    }, {
      path: "/login_2228/2228_impug",
      name: "2228_impug",
      components: {
        header: AppHeader,
        default: C2228_IMPUG,
        footer: AppFooter
      }
    }, {
      path: "/login_2303/2303_impugasd",
      name: "2303_impugasd",
      components: {
        header: AppHeader,
        default: C2303_IMPUG,
        footer: AppFooter
      }
    }, {
      path: "/login_2220/2220_gab_fiscobs1asd",
      name: "2220_gab_fiscobs1asd",
      components: {
        header: AppHeader,
        default: C2220_GABA_FO,
        footer: AppFooter
      }
    }, {
      path: "/login_2220/2220_CAD_fiscaboka",
      name: "2220_CAD_fiscaboka",
      components: {
        header: AppHeader,
        default: C2220_CADERNO_FO,
        footer: AppFooter
      }
    }, {
      path: "/login_2211/2211_res_dela_disasnas",
      name: "2211_res_dela_disasnas",
      components: {
        header: AppHeader,
        default: C2211_RES_DELEGADO,
        footer: AppFooter
      }
    }, {
      path: "/login_2220/2220_gab_def_cons",
      name: "2220_gab_def_cons",
      components: {
        header: AppHeader,
        default: C2220_CONSULTA_GABARITO_DEF,
        footer: AppFooter
      }
    }, {
      path: "/login_2224/2224_rec_insc",
      name: "2224_rec_insc",
      components: {
        header: AppHeader,
        default: C2224_REC_INSEN,
        footer: AppFooter
      }
    }, {
      path: "/login_2216/2216_rec_inse_absakjs",
      name: "2216_rec_inse_absakjs",
      components: {
        header: AppHeader,
        default: C2216_REC_ISENC_2,
        footer: AppFooter
      }
    },
    {
      path: "/login_2220/2220_rtec_habgaba",
      name: "2220_rtec_habgaba",
      components: {
        header: AppHeader,
        default: C2220_REC_GABA,
        footer: AppFooter
      }
    },
    {
      path: "/login_2217/2217_rec_insc",
      name: "2217_rec_insc",
      components: {
        header: AppHeader,
        default: C2217_REC_INSC,
        footer: AppFooter
      }
    },
    {
      path: "/login_2221/2221_resa_poxs",
      name: "2221_resa_poxs",
      components: {
        header: AppHeader,
        default: C2221_REC_PO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2216/2216_resa_insan",
      name: "2216_resa_insan",
      components: {
        header: AppHeader,
        default: C2216_RES_DEF_ISENCAO_2,
        footer: AppFooter
      }
    },
    {
      path: "/login_2219/2219_recsa_disc",
      name: "2219_recsa_disc",
      components: {
        header: AppHeader,
        default: C2219_RES_DISC,
        footer: AppFooter
      }
    },
    {
      path: "/login_2218/2218_rec_gabxa",
      name: "2218_rec_gabxa",
      components: {
        header: AppHeader,
        default: C2218_REC_GABA,
        footer: AppFooter
      }
    },
    {
      path: "/login_2219/2219_rec_poxkds",
      name: "2219_rec_poxkds",
      components: {
        header: AppHeader,
        default: C2219_REC_PO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2221/2221_recsa_gaba",
      name: "22221_recsa_gaba",
      components: {
        header: AppHeader,
        default: C2221_REC_GABA,
        footer: AppFooter
      }
    },
    {
      path: "/login_2214/2214_recsa_po",
      name: "2214_recsa-po",
      components: {
        header: AppHeader,
        default: C2214_REC_PO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2211/2211_rec_gaba_del",
      name: "2211_rec_gaba_del",
      components: {
        header: AppHeader,
        default: C2211_REC_GABA_DEL,
        footer: AppFooter
      }
    },
    {
      path: "/login_2211/2211_esp_inv",
      name: "2211_esp_inv",
      components: {
        header: AppHeader,
        default: C2211_ESP_INV,
        footer: AppFooter
      }
    },
    {
      path: "/login_2211/2211_esp_escr",
      name: "2211_esp_escr",
      components: {
        header: AppHeader,
        default: C2211_ESP_ESC,
        footer: AppFooter
      }
    },
    {
      path: "/login_2211/2211_rec_POXq",
      name: "2211_rec_POXq",
      components: {
        header: AppHeader,
        default: C2211_REC_PO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2211/2211_res_discaxcs",
      name: "2211_res_discaxcs",
      components: {
        header: AppHeader,
        default: C2211_RES_DISC,
        footer: AppFooter
      }
    },
    {
      path: "/login_2216/2216_rec_inscesna",
      name: "2216_rec_inscesna",
      components: {
        header: AppHeader,
        default: C2216_REC_ISENCAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2216/2216_res_def_inscesna",
      name: "2216_res_def_inscesna",
      components: {
        header: AppHeader,
        default: C2216_RES_DEF_ISENCAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2219/2219_rec_gabasx",
      name: "2219_rec_gabasx",
      components: {
        header: AppHeader,
        default: C2219_REC_GABARITO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2224/2224_recimpug",
      name: "2224_recimpug",
      components: {
        header: AppHeader,
        default: C2224_IMPUGNACAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2222/2222_rec_isencxasd",
      name: "2222_rec_isencxasd",
      components: {
        header: AppHeader,
        default: C2222_RES_INSENCAO,
        footer: AppFooter
      }
    },

    {
      path: "/login_2220/2220_res_const_gab",
      name: "2220_res_const_gab",
      components: {
        header: AppHeader,
        default: C2220_CONSULTA_GABARITO,
        footer: AppFooter
      }
    },

    {
      path: "/login_2214/2214_rec_gabts",
      name: "2214_rec_gabts",
      components: {
        header: AppHeader,
        default: C2214_REC_GABARITO,
        footer: AppFooter
      }
    },


    {
      path: "/login_2220/2220_res_const_caderno",
      name: "2220_res_const_caderno",
      components: {
        header: AppHeader,
        default: C2220_CONSULTA_CADERNO,
        footer: AppFooter
      }
    },

    {
      path: "/login_2216/2216_isen_rec",
      name: "2216_isen_rec",
      components: {
        header: AppHeader,
        default: C2216_RES_INSENCAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2218/2218_rec_insc",
      name: "2218_rec_insc",
      components: {
        header: AppHeader,
        default: C2218_REC_INSCRICAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2211/2211_rec_gabaxt",
      name: "2211_rec_gabaxt",
      components: {
        header: AppHeader,
        default: C2211_REC_GAB,
        footer: AppFooter
      }
    },
    {
      path: "/login_2217/2217_rec_ibaknsec2",
      name: "2217_rec_ibaknsec2",
      components: {
        header: AppHeader,
        default: C2217_REC_ISENCAO_2,
        footer: AppFooter
      }
    },
    {
      path: "/login_2207/2207_res_bancka",
      name: "2207_res_bancka",
      components: {
        header: AppHeader,
        default: C2207_RES_BANCA,
        footer: AppFooter
      }
    },
    {
      path: "/login_2207/2207_res_def_pcdssocial",
      name: "2207_res_def_pcdssocial",
      components: {
        header: AppHeader,
        default: C2207_RES_DEF_PCD,
        footer: AppFooter
      }
    },
    {
      path: "/login_2220/2220_res_insc",
      name: "2220_res_insc",
      components: {
        header: AppHeader,
        default: C2220_RES_INSCRICAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2207/2207_res_def_hehheter",
      name: "2207_res_def_hehheter",
      components: {
        header: AppHeader,
        default: C2207_RES_DEF_HETERO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2207/2207_rec_biopssicd",
      name: "2207_rec_biopssicd",
      components: {
        header: AppHeader,
        default: C2207_REC_PCD,
        footer: AppFooter
      }
    },
    {
      path: "/login_2207/2207_rec_hetks",
      name: "2207_rec_hetks",
      components: {
        header: AppHeader,
        default: C2207_REC_HETERO,
        footer: AppFooter
      }
    }, {
      path: "/login_2219/2219_rec_inscx",
      name: "2219_rec_inscx",
      components: {
        header: AppHeader,
        default: C2219_RES_INSC,
        footer: AppFooter
      }
    },
    {
      path: "/login_2219/2219_rec_inscx",
      name: "2219_rec_inscx",
      components: {
        header: AppHeader,
        default: C2219_RES_INSC,
        footer: AppFooter
      }
    },
    {
      path: "/login_2215/2215_rec_inscri",
      name: "2215_rec_inscri",
      components: {
        header: AppHeader,
        default: C2215_REC_INSCR,
        footer: AppFooter
      }
    },
    {
      path: "/login_2221/2221_rec_insoac",
      name: "2221_rec_insoac",
      components: {
        header: AppHeader,
        default: C2221_REC_ISENC,
        footer: AppFooter
      }
    },

    {
      path: "/login_2207/2207_res_biopssa",
      name: "2207_res_biopssa",
      components: {
        header: AppHeader,
        default: C2207_RES_PCD,
        footer: AppFooter
      }
    },


    {
      path: "/login_2207/2207_res_heteroxxasd",
      name: "2207_res_heteroxxasd",
      components: {
        header: AppHeader,
        default: C2207_RES_HETERO,
        footer: AppFooter
      }
    },

    {
      path: "/login_2218/2218_rec_iasenc",
      name: "2218_rec_iasenc",
      components: {
        header: AppHeader,
        default: C2218_REC_ISENC,
        footer: AppFooter
      }
    },
    {
      path: "/login_2207/C2207_Recurso_PO",
      name: "C2207_Recurso_PO",
      components: {
        header: AppHeader,
        default: C2207_Recurso_PO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2207/2207_rec_gabsx",
      name: "2207_rec_gabsx",
      components: {
        header: AppHeader,
        default: C2207_RES_GAB,
        footer: AppFooter
      }
    },

    {
      path: "/login_2219/2219_rec_ixsencx",
      name: "2219_rec_ixsencx",
      components: {
        header: AppHeader,
        default: C2219_REC_ISENC,
        footer: AppFooter
      }
    },
    {
      path: "/login_2216/2216_res_impu",
      name: "2216_res_impu",
      components: {
        header: AppHeader,
        default: C2216_RES_IMPU,
        footer: AppFooter
      }
    },


    {
      path: "/login_2217/2217_rec_isencx",
      name: "2217_rec_isenc",
      components: {
        header: AppHeader,
        default: C2217_REC_ISENC,
        footer: AppFooter
      }
    },
    {
      path: "/login_2220/2220_rec_isenadc",
      name: "2220_rec_isenc",
      components: {
        header: AppHeader,
        default: C2220_REC_ISENC,
        footer: AppFooter
      }
    },
    {
      path: "/login_2215/2215_rec_isenc",
      name: "2215_rec_isenc",
      components: {
        header: AppHeader,
        default: C2215_REC_ISENC,
        footer: AppFooter
      }
    },
    {
      path: "/login_2212/2212_rec_taf",
      name: "2212_rec_taf",
      components: {
        header: AppHeader,
        default: C2212_REC_TAF,
        footer: AppFooter
      }
    },
    {
      path: "/login_2211/2211_rec_inscra",
      name: "2211_rec_inscra",
      components: {
        header: AppHeader,
        default: C2211_REC_INSC,
        footer: AppFooter
      }
    },

    {
      path: "/login_2218/2218_impugnacaosa",
      name: "2218_impugnacaosa",
      components: {
        header: AppHeader,
        default: C2218_IMPUGNACAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2214/2214_rec_isen",
      name: "2214_rec_isen",
      components: {
        header: AppHeader,
        default: C2214_REC_INS,
        footer: AppFooter
      }
    },
    {
      path: "/login_2212/2212_rec_po",
      name: "2212_rec_po",
      components: {
        header: AppHeader,
        default: C2212_REC_PO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2205/2205_res_prem",
      name: "2205_res_prem",
      components: {
        header: AppHeader,
        default: C2205_REC_RES_PREM,
        footer: AppFooter
      }
    },
    {
      path: "/login_2208/2208_res_hets_def",
      name: "2208_res_hets_def",
      components: {
        header: AppHeader,
        default: C2208_RES_HETERO_DEF,
        footer: AppFooter
      }
    },
    {
      path: "/login_2208/2208_res_hets_def",
      name: "2208_res_hets_def",
      components: {
        header: AppHeader,
        default: C2208_RES_HETERO_DEF,
        footer: AppFooter
      }
    },

    {
      path: "/login_2208/2208_res_disc_def",
      name: "2208_res_disc_def",
      components: {
        header: AppHeader,
        default: C2208_RES_DISC_DEF,
        footer: AppFooter
      }
    },
    {
      path: "/login_2203/2203_just_inapt_exma",
      name: "2203_just_inapt_exma",
      components: {
        header: AppHeader,
        default: C2203_JUST_INAPT_EXAME,
        footer: AppFooter
      }
    },
    {
      path: "/login_2208/2208_rec_disc",
      name: "2208_rec_disc",
      components: {
        header: AppHeader,
        default: C2208_REC_DISC,
        footer: AppFooter
      }
    },
    {
      path: "/login_2208/2208_rec_heteroi",
      name: "2208_rec_heteroi",
      components: {
        header: AppHeader,
        default: C2208_REC_HETERO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2203/2203_res_def_qtuest",
      name: "2203_res_def_qtuest",
      components: {
        header: AppHeader,
        default: C2203_RES_DEF_QUEST,
        footer: AppFooter
      }
    },
    {
      path: "/login_2203/res_def_exma",
      name: "2203_res_def_exma",
      components: {
        header: AppHeader,
        default: C2203_RES_DEF_EXAME,
        footer: AppFooter
      }
    },
    {
      path: "/login_2203/2203_rec_examx",
      name: "2203_rec_examx",
      components: {
        header: AppHeader,
        default: C2203_REC_EXAME,
        footer: AppFooter
      }
    },
    {
      path: "/login_2203/2203_rec_quest",
      name: "2203_rec_quest",
      components: {
        header: AppHeader,
        default: C2203_REC_QUEST,
        footer: AppFooter
      }
    },
    {
      path: "/login_2210/2210_rec_titx",
      name: "2210_rec_titx",
      components: {
        header: AppHeader,
        default: C2210_RECURSO_TIT,
        footer: AppFooter
      }
    },
    {
      path: "/login_2209/2209_rec_titx",
      name: "2209_rec_titx",
      components: {
        header: AppHeader,
        default: C2209_RECURSO_TIT,
        footer: AppFooter
      }
    },
    {
      path: "/login_2205/2205_rec_taf",
      name: "2205_rec_taf",
      components: {
        header: AppHeader,
        default: C2205_RECURSO_TAF,
        footer: AppFooter
      }
    },
    {
      path: "/login_2205/2205_nota_tit_def",
      name: "2205_nota_tit_def",
      components: {
        header: AppHeader,
        default: C2205_Nota_Tit_Def,
        footer: AppFooter
      }
    },
    {
      path: "/login_2205/2205_rec_laudo_pcd",
      name: "2205_rec_laudo_pcd",
      components: {
        header: AppHeader,
        default: C2205_RECURSO_LAUDO,
        footer: AppFooter
      }
    },

    {
      path: "/login_2205/2205_res_laudo_pcd_def",
      name: "2205_res_laudo_pcd_def",
      components: {
        header: AppHeader,
        default: C2205_LAUDO_PCD_DEF,
        footer: AppFooter
      }
    },

    {
      path: "/login_2205/2205_rec_tit",
      name: "2205_rec_tit",
      components: {
        header: AppHeader,
        default: C2205_RECURSO_TITULO,
        footer: AppFooter
      }
    },

    {
      path: "/login_2208/2208_res_het",
      name: "2208_res_het",
      components: {
        header: AppHeader,
        default: C2208_RES_HETERO,
        footer: AppFooter
      }
    },

    {
      path: "/login_2209/2209_res_ttx",
      name: "2209_res_ttx",
      components: {
        header: AppHeader,
        default: C2209_Nota_Tit,
        footer: AppFooter
      }
    },

    {
      path: "/login_2210/2210_res_ttlos",
      name: "2210_res_ttlos",
      components: {
        header: AppHeader,
        default: C2210_Nota_Tit,
        footer: AppFooter
      }
    },
    {
      path: "/login_2208/2208_res_disc",
      name: "2208_res_disc",
      components: {
        header: AppHeader,
        default: C2208_RES_DISC,
        footer: AppFooter
      }
    },

    {
      path: "/login_2208/2208_res_pop",
      name: "2208_res_pop",
      components: {
        header: AppHeader,
        default: C2208_RECURSO_PO,
        footer: AppFooter
      }
    },

    {
      path: "/login_2209/2209_res_popa",
      name: "2209_res_popa",
      components: {
        header: AppHeader,
        default: C2209_RECURSO_PO,
        footer: AppFooter
      }
    },
    {
      path: "/login_22010/2210_res_popa",
      name: "2210_res_popa",
      components: {
        header: AppHeader,
        default: C2210_RECURSO_PO,
        footer: AppFooter
      }
    },


    {
      path: "/login_2203/2203_res_exasd",
      name: "2203_res_exasd",
      components: {
        header: AppHeader,
        default: C2203_Recurso_EXAME,
        footer: AppFooter
      }
    },


    {
      path: "/login_2203/2203_res_qxesy",
      name: "2203_res_qxesy",
      components: {
        header: AppHeader,
        default: C2203_Recurso_QUESTINARIO,
        footer: AppFooter
      }
    },

    {
      path: "/login_2209/2209_rec_gab",
      name: "2209_rec_gab",
      components: {
        header: AppHeader,
        default: C2209_Recurso_GABARITO,
        footer: AppFooter
      }
    },

    {
      path: "/login_2210/2210_res_gab",
      name: "2210_res_gab",
      components: {
        header: AppHeader,
        default: C2210_Recurso_GABARITO,
        footer: AppFooter
      }
    },

    {
      path: "/login_2212/2212_res_gab",
      name: "2212_res_gab",
      components: {
        header: AppHeader,
        default: C2212_Recurso_GABARITO,
        footer: AppFooter
      }
    },

    {
      path: "/login_2215/2215_res_imp",
      name: "2215_res_imp",
      components: {
        header: AppHeader,
        default: C2215_Recurso_IMPUGNACAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2205/2205_res_ld_pd",
      name: "2205_res_ld_pd",
      components: {
        header: AppHeader,
        default: C2205_RES_LAUDO_PCD,
        footer: AppFooter
      }
    },
    {
      path: "/login_2205/2205_rest_tits",
      name: "2205_rest_tits",
      components: {
        header: AppHeader,
        default: C2205_Nota_Tit,
        footer: AppFooter
      }
    }, {
      path: "/login_2204/2204_rec_prem",
      name: "2204_rec_prem",
      components: {
        header: AppHeader,
        default: C2204_Recurso_RES_PREM,
        footer: AppFooter
      }
    }, {
      path: "/login_2207/2207_rec_inscc",
      name: "2207_rec_inscc",
      components: {
        header: AppHeader,
        default: C2207_Recurso_INSCRICAO,
        footer: AppFooter
      }
    }, {
      path: "/login_2206/2206_rec_po",
      name: "2206_rec_po",
      components: {
        header: AppHeader,
        default: C2206_RECURSO_PO,
        footer: AppFooter
      }
    }, {
      path: "/login_2204/2204_disc_def_",
      name: "2204_disc_def_",
      components: {
        header: AppHeader,
        default: C2204_Nota_DISC_DEF,
        footer: AppFooter
      }
    }
    , {
      path: "/login_2205/2205_disc_def",
      name: "2205_disc_def",
      components: {
        header: AppHeader,
        default: C2205_Nota_DISC_DEF,
        footer: AppFooter
      }
    }

    , {
      path: "/login_2208/2208_rec_gbb",
      name: "2208_rec_gbb",
      components: {
        header: AppHeader,
        default: C2208_Recurso_GABARITO,
        footer: AppFooter
      }
    }

    , {
      path: "/login_2205/2205_rec_disc",
      name: "2205_rec_disc",
      components: {
        header: AppHeader,
        default: C2205_RECURSO_DISC,
        footer: AppFooter
      }
    }
    , {
      path: "/login_2204/2204_rec_discc",
      name: "2204_tit_def",
      components: {
        header: AppHeader,
        default: C2204_RECURSO_DISC,
        footer: AppFooter
      }
    }

    , {
      path: "/login_2204/2204_tit_def",
      name: "2204_tit_def",
      components: {
        header: AppHeader,
        default: C2204_Nota_Titulos_DEF,
        footer: AppFooter
      }
    },
    {
      path: "/login_2204/rec_titts",
      name: "2204_rec_titts",
      components: {
        header: AppHeader,
        default: C2204_Recurso_TITULO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2205/rec_gabbs",
      name: "2206_rec_gabbs",
      components: {
        header: AppHeader,
        default: C2206_Recurso_GABARITO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2205/rec_obj",
      name: "2205_rec_obj",
      components: {
        header: AppHeader,
        default: C2205_RECURSO_PO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2205/n_disc",
      name: "2205_n_disc",
      components: {
        header: AppHeader,
        default: C2205_DISCURSIVA,
        footer: AppFooter
      }
    },
    {
      path: "/login_2201/rec_tit",
      name: "2201_rec_tit",
      components: {
        header: AppHeader,
        default: C2201_Recurso_Titulos,
        footer: AppFooter
      }
    },
    {
      path: "/login_2204/2204_not_red_disc",
      name: "2204_not_red_disc",
      components: {
        header: AppHeader,
        default: C2204_Nota_Discursiva,
        footer: AppFooter
      }
    },
    {
      path: "/login_2204/2204_not_discx",
      name: "2204_not_discx",
      components: {
        header: AppHeader,
        default: C2204_Nota_Titulos,
        footer: AppFooter
      }
    },
    {
      path: "/login_2205/2205_rec_gabb",
      name: "2205_rec_gabb",
      components: {
        header: AppHeader,
        default: C2205_Recurso_GABARITO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2211/2211_rec_iseny",
      name: "2211_rec_iseny",
      components: {
        header: AppHeader,
        default: C2211_Recurso_ISENCAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2210/2210_rec_xinsc",
      name: "2210_rec_xinsc",
      components: {
        header: AppHeader,
        default: C2210_Recurso_INSCRICAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2212/2212_rec_xinscx",
      name: "2212_rec_xinscx",
      components: {
        header: AppHeader,
        default: C2212_Recurso_INSCRICAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2201/2201_rec_prat",
      name: "2201_rec_prat",
      components: {
        header: AppHeader,
        default: C2201_Recurso_Pratica,
        footer: AppFooter
      }
    },
    {
      path: "/login_2209/2209_rec_inx",
      name: "2209_rec_inx",
      components: {
        header: AppHeader,
        default: C2209_Recurso_INSCRICAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2201/2201_rec_disc",
      name: "2201_rec_disc",
      components: {
        header: AppHeader,
        default: C2201_Recurso_Discursiva,
        footer: AppFooter
      }
    },
    {
      path: "/login_2201/2201_prem_titi",
      name: "2201_prem_titi",
      components: {
        header: AppHeader,
        default: C2201_Preliminar_Titulos,
        footer: AppFooter
      }
    },
    {
      path: "/login_2211/2211_imps",
      name: "2211_imp",
      components: {
        header: AppHeader,
        default: C2211_Recurso_IMPUGNACAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2208/2208_rec_inc",
      name: "2208_rec_inc",
      components: {
        header: AppHeader,
        default: C2208_Recurso_INSCRICAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2201/2201_prov_pr",
      name: "2201_prov_pr",
      components: {
        header: AppHeader,
        default: C2201_Prova_Pratica,
        footer: AppFooter
      }
    }, {
      path: "/login_2202/2202_rec_cl",
      name: "2202_rec_cl",
      components: {
        header: AppHeader,
        default: C2202_Recurso_Classificacao,
        footer: AppFooter
      }
    },
    {
      path: "/login_2210/2210_rec_isnx",
      name: "2210_rec_isnx",
      components: {
        header: AppHeader,
        default: C2210_Recurso_ISENCAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2206/2206_rec_insri",
      name: "2206_rec_insri",
      components: {
        header: AppHeader,
        default: C2206_Recurso_INSCRICAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2205/2205_rec_inscra",
      name: "2205_rec_inscra",
      components: {
        header: AppHeader,
        default: C2205_Recurso_PO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2212/2212_rec_hhhisen",
      name: "2212_rec_hhhisen",
      components: {
        header: AppHeader,
        default: C2212_Recurso_PO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2204/2204_rec_POX",
      name: "2204_rec_POX",
      components: {
        header: AppHeader,
        default: C2204_Recurso_PO,
        footer: AppFooter
      }
    }, {
      path: "/login_2208/2208_rec_ins",
      name: "2208_rec_ins",
      components: {
        header: AppHeader,
        default: C2208_Recurso_ISENCAO,
        footer: AppFooter
      }
    }, {
      path: "/login_2202/2202_rec_ttls",
      name: "login",
      components: {
        header: AppHeader,
        default: C2202_Recurso_TITULOS,
        footer: AppFooter
      }
    },
    {
      path: "/login_2204/2204_rec_gabxt",
      name: "login",
      components: {
        header: AppHeader,
        default: C2204_Recurso_GABARITO,
        footer: AppFooter
      }
    }, {
      path: "/login_2209/2209_rec_ins",
      name: "login",
      components: {
        header: AppHeader,
        default: C2209_Recurso_ISENCAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2207/2207_rec_ins",
      name: "login",
      components: {
        header: AppHeader,
        default: C2207_Recurso_ISENCAO,
        footer: AppFooter
      }
    },
    {
      path: "/login_2202/2202_rec_ptra",
      name: "login",
      components: {
        header: AppHeader,
        default: C2202_Recurso_PRAT,
        footer: AppFooter
      }
    },
    {
      path: "/login_2106/2106_rec_cl",
      name: "login",
      components: {
        header: AppHeader,
        default: C2106_Recurso_Classificacao,
        footer: AppFooter
      }
    },
    {
      path: "/login_2112/2112_rec_isc",
      name: "2112_rec_isc",
      components: {
        header: AppHeader,
        default: C2112_Recurso_ISENCAO,
        footer: AppFooter
      },
    }, {
      path: "/login_2113/2113_rec_isc_las",
      name: "2113_rec_isc_las",
      components: {
        header: AppHeader,
        default: C2113_Recurso_ISENCAO,
        footer: AppFooter
      },
    },
    {
      path: "/login_2111/2111_rec_gabs",
      name: "2111_rec_gabs",
      components: {
        header: AppHeader,
        default: C2111_Recurso_GABARITO,
        footer: AppFooter
      },
    },
    {
      path: "/login_2110/2110_rec_gabs",
      name: "2110_rec_gabs",
      components: {
        header: AppHeader,
        default: C2110_Recurso_GABARITO,
        footer: AppFooter
      },
    },
    {
      path: "/login_2203/2203_rec_ped_ins",
      name: "2203_rec_ped_ins",
      components: {
        header: AppHeader,
        default: C2203_Recurso_ISENCAO,
        footer: AppFooter
      },
    },
    {
      path: "/login_2110/2110_rec-po",
      name: "2110_rec",
      components: {
        header: AppHeader,
        default: C2110_Recurso_PO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2111/2111_rec-po",
      name: "2111_rec",
      components: {
        header: AppHeader,
        default: C2111_Recurso_PO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2204/2204_rec-ped-isen",
      name: "2204_rec-ped-isen",
      components: {
        header: AppHeader,
        default: C2204_Recurso_ISENCAO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2113/2113_rec-inscr",
      name: "2113_rec-inscr",
      components: {
        header: AppHeader,
        default: C2113_Recurso_INSCRICAO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2114/2114_rec-inscr",
      name: "2114_rec-inscr",
      components: {
        header: AppHeader,
        default: C2114_Recurso_INSCRICAO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2203/2203_rec-inscr_2",
      name: "2203_rec-inscr_2",
      components: {
        header: AppHeader,
        default: C2203_Recurso_ISENCAO_2,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2201/2201_recx-inscrs",
      name: "2201_recx-inscrs",
      components: {
        header: AppHeader,
        default: C2201_Recurso_INSCRICAO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2202/2202_rec-inscra",
      name: "2202_rec-inscra",
      components: {
        header: AppHeader,
        default: C2202_Recurso_INSCRICAO,
        footer: AppFooter,
      },
    }, {
      path: "/login_2205/2205_rec-impu",
      name: "2205_rec-impu",
      components: {
        header: AppHeader,
        default: C2205_Recurso_IMPUGNACAO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2113/2113_reb_gabx",
      name: "2113_reb_gabx-impu",
      components: {
        header: AppHeader,
        default: C2113_Recurso_GABARITO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2113/2113_rec_pcdx",
      name: "2113_rec_pcdx",
      components: {
        header: AppHeader,
        default: C2113_Recurso_PCD,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2112/2112_rec_pcdx",
      name: "2112_rec_pcdx",
      components: {
        header: AppHeader,
        default: C2112_Recurso_PCD,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2203/2203_ins_rec",
      name: "2203_ins_rec",
      components: {
        header: AppHeader,
        default: C2203_Recurso_INSCRICAO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2112/2112_reb_gabx",
      name: "2112_reb_gabx",
      components: {
        header: AppHeader,
        default: C2112_Recurso_GABARITO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2112/2112_rebx_po",
      name: "2112_rebx_po",
      components: {
        header: AppHeader,
        default: C2112_Recurso_PO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2113/2113_recx_po",
      name: "2113_recx_po",
      components: {
        header: AppHeader,
        default: C2113_Recurso_PO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_1922/1922_rec_qwe",
      name: "1922_rec_qwe",
      components: {
        header: AppHeader,
        default: C1922_Recurso_HETERO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2114/2114_rec_gaba",
      name: "2114_rec_gaba",
      components: {
        header: AppHeader,
        default: C2114_Recurso_GABARITO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2204/2204_rec_inscsx",
      name: "2204_rec_inscsx",
      components: {
        header: AppHeader,
        default: C2204_Recurso_INSCRICAO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2201/2201_rec_ga",
      name: "2201_rec_ga",
      components: {
        header: AppHeader,
        default: C2201_Recurso_GABARITO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2202/2202_rec_ga",
      name: "2202_rec_ga",
      components: {
        header: AppHeader,
        default: C2202_Recurso_GABARITO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2201/2201_zrecx_po",
      name: "2201_zrecx_po",
      components: {
        header: AppHeader,
        default: C2201_Recurso_PO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2202/2202_zrecx_po",
      name: "2202_zrecx_po",
      components: {
        header: AppHeader,
        default: C2202_Recurso_PO,
        footer: AppFooter,
      },
    }, {
      path: "/login_2114/2114_zrescx_po",
      name: "2114_zrescx_po",
      components: {
        header: AppHeader,
        default: C2114_Recurso_PO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2114/2114_zrescx_pcdx",
      name: "2114_zrescx_pcdx",
      components: {
        header: AppHeader,
        default: C2114_Recurso_PCD,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2205/2205_zrescx_isn",
      name: "2205_zrescx_isn",
      components: {
        header: AppHeader,
        default: C2205_Recurso_ISENCAO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2114/2114_res_tit",
      name: "2114_res_tit",
      components: {
        header: AppHeader,
        default: C2114_Recurso_TITULO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2207/2207_rec_imp",
      name: "2207_rec_imp",
      components: {
        header: AppHeader,
        default: C2207_Recurso_IMPUGNACAO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2206/2206_rec_isenc",
      name: "2206_rec_isenc",
      components: {
        header: AppHeader,
        default: C2206_Recurso_ISENCAO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2203/2203_rec_ga",
      name: "2203_rec_ga",
      components: {
        header: AppHeader,
        default: C2203_Recurso_GABARITO,
        footer: AppFooter,
      },
    },
    {
      path: "/login_2203/2203_rec_po",
      name: "2203_rec_po",
      components: {
        header: AppHeader,
        default: C2203_Recurso_PO,
        footer: AppFooter,
      },
    },
    {
      path: "/isencao",
      name: "isencao",
      components: {
        header: AppHeader,
        default: Isencao,
        footer: AppFooter,
      },
      meta: {
        requiresAuth: true,
      }
    }
    ,
    {
      path: "/impugnacao",
      name: "impugnacao",
      components: {
        header: AppHeader,
        default: Impugnacao,
        footer: AppFooter,
      },
    }
    ,
    {
      path: "/protocoloimpugnacao",
      name: "protocoloimpugnacao",
      components: {
        header: AppHeader,
        default: ProtocoloImpugnacao,
        footer: AppFooter,
      },
    },
    {
      path: "/2106_prat_dig_wqweqra",
      name: "2109_Pratica_Digitador",
      components: {
        header: AppHeader,
        default: C2109_Pratica_Digitador,
        footer: AppFooter,
      },
    },
    {
      path: "/pgmprotocolo",
      name: "pgmprotocolo",
      components: {
        header: AppHeader,
        default: PGM_Protocolo,
        footer: AppFooter,
      },
    },

    //DEMAIS

    {
      path: "/login_2109/2109_rec_pt",
      name: "login",
      components: {
        header: AppHeader,
        default: C2109_Recurso_Pratica,
        footer: AppFooter
      }
    },

    {
      path: "/login_2109/2109_rec_cl",
      name: "login",
      components: {
        header: AppHeader,
        default: C2109_Recurso_Classificacao,
        footer: AppFooter
      }
    },
    {
      path: "/login_2002/2002_rec_avps",
      name: "login",
      components: {
        header: AppHeader,
        default: C2002_Recurso_AV_PSICO,
        footer: AppFooter
      }
    },


  ],
  scrollBehavior: to => {
    if (to.hash) {
      return {selector: to.hash};
    } else {
      return {x: 0, y: 0};
    }
  }
});


router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem("token") == null) {
      next({
        path: `/login/${localStorage.getItem('concurso')}`,
        // path: `/login`,
        params: {nextUrl: to.fullPath},
      });
    } else {
      next();
    }
  } else {
    next();
  }
});


export default router;
